import React, { CSSProperties, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import clsx from 'clsx';

/** ide_wireframe_frontend ile aynı placeholder görselleri (loading / error). */
export const ideImagePlaceholderDataUrls = {
  error:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAA+CAYAAADJYiAkAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKtSURBVHgB7ZjLbtpAFIbPzHhwIDRAEAIBQYigCInueJBK3UR5Gx6GBa/SBcqircKChUsjmgpIgKiAY8dTHytGXAz4tuSTEmRjPg4/4+NjCDjQbDZpu91OSZoWW6iqzCMRqr29GVFZVjkhS5pITDqdjrb9OrItabVaackwUnCMSGTc7XbHjrJGo8Hnz895QYgMLiFCqLHLy4FdJbWf8CpC8Hh8XfPDw/BfrVBIgyR9Aj8QIv3IZsVoNFpQ/Hggy2kIANW0VNN8YJzzBKf0HAIgzPqwOnrBeRxCAJcRNQA8hb4P9FBDCAohgB5KCTEgJKgwDA1CABcw1RibQwhQlCXm838QAplyeWKdm5+vr690IaLgE2YYs5+K8mR9k3Iy+eT3i4hwrp2l01b3WHWNcrl8FmOs6GWpYAHz9/dHRVGW1rb9BO6IJpO/OGO6GxE2SjzeFm1Utk6lUknIQiSdWpJEyOKckOm3Xm8GXsDO28jnY/iHMeD2vmNrtVqgzrN6Q1wNtUrlhkAAsBfOhsMrJkkSbvuW1ev1+HI6zeGVy97nS2a1eYfuzMADmM9QUbKCc8dLoevK3FwKXclMUcwMOmcH7VtWKpVSMUnKgAsOyqrVasbVqHBIhvmok0nOa1vakeFpww0jfywfJzbONfNjXTBdL/oRbVS2byF6qgwX4k2xWAgqQthgMMibHTPQrGFDqa6HIrJkECIn2Ul2koUjMserUGQ48OGcFliGI9bXuztrTiM4vYBPopS+3Pd6w5UYfID5ME0b3/f7L+v7Pcswn5mq/lH6/eXOm4AHrBv+ePxxfY71VZmVz8PD8NAxrmRc14fb+XiW2fl0HfJxYm9mx/JxLcN8vtze/nb6VeUQO4sW8/nuIh8nVplhPvz19W9nMPB9/0nxXgnPL8wniAj5Dy4XFrX04qDRAAAAAElFTkSuQmCC',
  loading:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAA+CAYAAADJYiAkAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJnSURBVHgB7ZZBbtpAFIbfG0wUWHEEI1rJS/cEhRM0OUHDriKRSk9Ae4KCVGVbeoL2BtAT1JtEltrIcwQ2EVICnr4ZxwTDxIztWfJvPMzgT+/98+Z5EDQSrttaNZsfQYguIPr0bNFzQc+AlgNHiAmGId99D/cgjcaIhkM4JMTP9dvbL1rY0vNcB/EnDX0wl4zyPI2SpbMlQFL+it6TGW1gj543KgF6BjabyhZ8Si+Calo4y2Wb1RDPoLrk7g8Z7cA7sCEh3jJVR3bkM1WQdtRiqrItSZYGBxtCDGSav8GCaCMV7BdYUIw4YfUwnNN4DhWEiNOTm5tAHaeVEP2yG0Hp8Vocq+6hYA069QKxVxhI/48Z23SNTD+T55SO14wmXQNUpv3swVI9eN4FMiY7re50zIUQP07CcLq7oIWlUp339FQBRa22qN/fc+Rcb8XgbpQLM9IwasHjWjbWbjXYh8iFWjyTOcifDMrq6t8Zgf6koPIw8gcEUGrZjlMszcSfrzS60C2bwxJ/ZDQvNlOzNK/+dp+Mzu3Kh2GDiIoXZ9tGv6T8NC/vyB9x+KqQC1P+rL/TqAsF5OzNDCIfUBptdNgzynp2Gb0nkJE/+TBZiLCe7hZiEaEqxAfyB6HyNYHZAiUwS6AEZlFH2BF2hFkSLizBkINgveowpCtsnb2B63bgQBUhTODbq83Xq2Rk8roqPm2DpEpEpvw5h+tOsLtSMDIMyJ+e9Ee3ah6Z8qeT+3U3jGzfH50ORJb6o08LzCPL98ccJv2RoHGbQwFp0pT+vB5DCW3ByB+M+wSaQ0k5CURwcFgfxh0OFfQfpJrbS67esn8AAAAASUVORK5CYII=',
} as const;

export interface IPImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'loading' | 'ref'> {
  ref?: React.Ref<HTMLImageElement>;
  src?: string | null;
  objectFit?: CSSProperties['objectFit'];
  objectPosition?: string;
  loading?: 'lazy' | 'eager';
  wrapperClassName?: string;
  /** Görünür alana yaklaşmadan yüklemeyi başlatmak için (px veya %). */
  rootMargin?: string;
  enablePlaceholderOn?: { error?: boolean; loading?: boolean };
  doNotUseWrapper?: boolean;
  styleParams?: CSSProperties;
  onLoadComplete?: () => void;
}

const PLACEHOLDER_ICON_W = 19 / 2;
const PLACEHOLDER_ICON_H = 62 / 2;

const IPImage: React.FC<IPImageProps> = (props) => {
  const {
    src,
    alt = '',
    loading = 'lazy',
    className = '',
    wrapperClassName,
    style,
    styleParams,
    width,
    height,
    objectFit,
    objectPosition,
    title,
    rootMargin = '160px',
    enablePlaceholderOn = { loading: false, error: false },
    doNotUseWrapper = false,
    onLoadComplete,
    onLoad,
    onError,
    onLoadStart,
    ref: externalImgRef,
    ...rest
  } = props;

  const containerRef = useRef<HTMLDivElement>(null);
  const imgRef = useRef<HTMLImageElement | null>(null);
  /** Wrapper yoksa gözlem yapılamaz; doğrudan yükleme yapılır. */
  const [inView, setInView] = useState(() => doNotUseWrapper);
  const [imageState, setImageState] = useState<'loading' | 'loaded' | 'error'>(() =>
    enablePlaceholderOn?.loading ? 'loading' : 'loaded',
  );

  const resolvedSrc = useMemo(() => {
    if (!src) return undefined;
    const s = String(src).trim();
    return s || undefined;
  }, [src]);

  useEffect(() => {
    if (doNotUseWrapper) return;
    if (typeof IntersectionObserver === 'undefined') {
      setInView(true);
      return;
    }
    const el = containerRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { root: null, rootMargin, threshold: 0.01 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [doNotUseWrapper, rootMargin]);

  useEffect(() => {
    if (!inView) return;
    if (!resolvedSrc) {
      setImageState('error');
      return;
    }
    setImageState(enablePlaceholderOn?.loading ? 'loading' : 'loaded');
  }, [inView, resolvedSrc, enablePlaceholderOn?.loading]);

  /**
   * Önbellekten anında gelen görsellerde onLoad bazen çalışmaz; placeholder loading'de kalır.
   * IO + native loading="lazy" üst üste bindiğinde bazı tarayıcılarda yükleme ertelenip takılı kalabiliyor.
   */
  useLayoutEffect(() => {
    if (!inView || !resolvedSrc) return;
    const el = imgRef.current;
    if (!el) return;
    if (el.complete && el.naturalWidth > 0) {
      setImageState('loaded');
    }
  }, [inView, resolvedSrc]);

  const handleLoadStart = useCallback(
    (e: React.SyntheticEvent<HTMLImageElement>) => {
      if (enablePlaceholderOn?.loading) setImageState('loading');
      onLoadStart?.(e);
    },
    [enablePlaceholderOn?.loading, onLoadStart],
  );

  const handleLoad = useCallback(
    (e: React.SyntheticEvent<HTMLImageElement>) => {
      setImageState('loaded');
      onLoadComplete?.();
      onLoad?.(e);
    },
    [onLoad, onLoadComplete],
  );

  const handleError = useCallback(
    (e: React.SyntheticEvent<HTMLImageElement>) => {
      setImageState('error');
      onError?.(e);
    },
    [onError],
  );

  const showWaitingForView = Boolean(enablePlaceholderOn?.loading && !inView);
  const showImageLoading = Boolean(enablePlaceholderOn?.loading && inView && imageState === 'loading');
  const showError = Boolean(enablePlaceholderOn?.error && imageState === 'error');

  const PlaceholderLayer = () => {
    if (showError) {
      return (
        <div
          className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ zIndex: 2, backgroundColor: '#F5F5F5' }}
          aria-hidden
        >
          <img alt="" src={ideImagePlaceholderDataUrls.error} width={PLACEHOLDER_ICON_W} height={PLACEHOLDER_ICON_H} />
        </div>
      );
    }
    if (showWaitingForView || showImageLoading) {
      return (
        <div
          className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ zIndex: 2, backgroundColor: '#F5F5F5' }}
          aria-hidden
        >
          <img alt="" src={ideImagePlaceholderDataUrls.loading} width={PLACEHOLDER_ICON_W} height={PLACEHOLDER_ICON_H} />
        </div>
      );
    }
    return null;
  };

  const mergedStyle: CSSProperties = {
    ...styleParams,
    ...style,
    ...(objectFit != null ? { objectFit, display: 'block' } : {}),
    ...(objectPosition != null ? { objectPosition } : {}),
  };

  /** Bootstrap .h-100 / .w-100 çoğu kurulumda !important kullanır; sabit thumbnail için min/max ile kutuyu kilitle. */
  const wrapperStyle = useMemo((): CSSProperties => {
    const base: CSSProperties = { width, height };
    const wn = typeof width === 'number' && Number.isFinite(width) ? width : undefined;
    const hn = typeof height === 'number' && Number.isFinite(height) ? height : undefined;
    if (wn != null && hn != null) {
      return {
        ...base,
        minWidth: wn,
        maxWidth: wn,
        minHeight: hn,
        maxHeight: hn,
        flexShrink: 0,
      };
    }
    return base;
  }, [width, height]);

  const shouldRenderImg = inView && resolvedSrc && imageState !== 'error';

  /** Görünürlük zaten IO ile bekletildi; native lazy ikinci kez erteleme yapıp takılmaya yol açabiliyor. */
  const imgLoadingAttr: 'eager' | 'lazy' = doNotUseWrapper ? loading : 'eager';

  const setImgRef = useCallback(
    (node: HTMLImageElement | null) => {
      imgRef.current = node;
      if (typeof externalImgRef === 'function') {
        externalImgRef(node);
      } else if (externalImgRef && 'current' in externalImgRef) {
        (externalImgRef as React.MutableRefObject<HTMLImageElement | null>).current = node;
      }
    },
    [externalImgRef],
  );

  const inner = (
    <>
      <PlaceholderLayer />
      {shouldRenderImg ? (
        <img
          key={resolvedSrc}
          ref={setImgRef}
          src={resolvedSrc}
          alt={alt}
          width={width as number | string | undefined}
          height={height as number | string | undefined}
          loading={imgLoadingAttr}
          decoding="async"
          className={clsx('position-relative', className)}
          style={{ ...mergedStyle, zIndex: 1 }}
          onLoadStart={handleLoadStart}
          onLoad={handleLoad}
          onError={handleError}
          {...rest}
        />
      ) : null}
    </>
  );

  if (doNotUseWrapper) {
    return <>{inner}</>;
  }

  return (
    <div
      ref={containerRef}
      className={clsx('position-relative overflow-hidden', wrapperClassName)}
      style={wrapperStyle}
      title={title}
    >
      {inner}
    </div>
  );
}

export default React.memo(IPImage);
